import { useEffect, useRef } from 'react';

const DESKTOP_MQ = '(min-width: 769px)';

export function useDesktopAutofocus(enabled = true) {
    const ref = useRef(null);

    useEffect(() => {
        if (!enabled || typeof window === 'undefined') return;
        if (!window.matchMedia(DESKTOP_MQ).matches) return;

        const id = requestAnimationFrame(() => {
            ref.current?.focus({ preventScroll: true });
        });

        return () => cancelAnimationFrame(id);
    }, [enabled]);

    return ref;
}
